import { render } from "./floorIframe.vue?vue&type=template&id=13ff4138&scoped=true"
import script from "./floorIframe.vue?vue&type=script&lang=js"
export * from "./floorIframe.vue?vue&type=script&lang=js"

import "./floorIframe.vue?vue&type=style&index=0&id=13ff4138&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ff4138"]])

export default __exports__